// MODULES
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule  } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './/app-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FileDropModule } from 'ngx-file-drop';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { AngularDraggableModule } from 'angular2-draggable';

// SERVICES
import { NotificationService } from './services/notification.service';

// COMPONENTS
import { AppComponent } from './app.component';
import { SnackBarResponse } from './snack-bar-response/snack-bar-response.component';
import { LoaderComponent } from './loader/loader.component';
import { LoaderService } from './services/loader.service';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { LoaderInterceptor } from './loader.interceptor';
import { MatSnackBarModule,
  MatFormFieldModule,
  MatSelectModule,
  MatCheckboxModule,
  MatInputModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatDialogModule,
  MatProgressSpinnerModule} from '@angular/material';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatRadioModule } from '@angular/material/radio';
import { TooltipModule } from 'ng2-tooltip-directive';

// ngx-dropzone wrapper
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { ConfirmationDialogComponent } from './shared/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './shared/confirmation-dialog/ConfirmationDialogService';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { CardRegistrationService } from './services/card-registration.service';
import { CardRegistrationComponent } from './card-registration-form/card-registration.component';
import { ErrorComponent } from './error/error.component';
import { VersionCheckComponent } from './version-check/version-check.component';

const DROPZONECONFIG: DropzoneConfigInterface = {
  url: 'https://httpbin.org/post',
  maxFilesize: 200
};

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    SnackBarResponse,
    CardRegistrationComponent,
    ConfirmationDialogComponent,
    ErrorComponent,
    VersionCheckComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    TooltipModule,
    FileDropModule,
    FormsModule,
    NgbModule,
    AutocompleteLibModule,
    DropzoneModule,
    AngularDraggableModule,
    DragDropModule,
    ScrollingModule
  ],
  entryComponents: [
    SnackBarResponse,
    ConfirmationDialogComponent
    ],
  providers: [
    LoaderService,
    CardRegistrationService,
    NotificationService,
    ConfirmationDialogService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: DROPZONE_CONFIG, useValue: DROPZONECONFIG }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
